import { render, staticRenderFns } from "./masd.vue?vue&type=template&id=5d74a75e&lang=pug"
import script from "./masd.vue?vue&type=script&setup=true&lang=js"
export * from "./masd.vue?vue&type=script&setup=true&lang=js"
import style0 from "./masd.vue?vue&type=style&index=0&id=5d74a75e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports